import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const MPMCModules = () => {
  const modules = [
    'Module 1',  'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Module 1 (ALL)', path: '/mpmc-m1-s1' }
    ],
    'Module 3': [
      { name: '8051 Organization and Architecture', path: '/mpmc-m3-s1' },
      { name: 'RAM and ROM Organization', path: '/mpmc-m3-s2' },
      { name: 'Machine Cycle', path: '/mpmc-m3-s3' },
      { name: 'Addressing Modes', path: '/mpmc-m3-s4' },
      { name: 'Data Processing - Stack', path: '/mpmc-m3-s5' },
      { name: 'Arithmetic Instructions', path: '/mpmc-m3-s6' },
      { name: 'Logical Instructions', path: '/mpmc-m3-s7' },
      { name: 'Branching: Conditional and Unconditional', path: '/mpmc-m3-s8' },
      { name: 'Module Summary', path: '/mpmc-m3-s9' }
    ],
    'Module 4': [
      { name: 'I/O Ports', path: '/mpmc-m4-s1' },
      { name: 'Timers & Counters', path: '/mpmc-m4-s2' },
      { name: 'Serial Communication', path: '/mpmc-m4-s3' },
      { name: 'Interrupts', path: '/mpmc-m4-s4' }
    ],
    'Module 5': [
      { name: 'LCD', path: '/mpmc-m5-s1' },
      { name: 'LED', path: '/mpmc-m5-s2' },
      { name: 'KEYPAD INTERFACING', path: '/mpmc-m5-s3' },
      { name: 'ADC & DAC', path: '/mpmc-m5-s4' }
    ],
    'Module 6': [
      { name: 'ARM Architecture and Processor Fundamentals', path: '/mpmc-m6-s1' }
    ],
    'Module 7': [
      { name: 'ARM Addressing Modes & Instruction Set', path: '/mpmc-m7-s1' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Microprocessor and Microcontroller</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module].map((topic, index) => (
                  <li key={index}>
                    <span>{topic.name}</span>
                    <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-MPMCModules' }}>
                      <FontAwesomeIcon icon={faFileAlt} />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MPMCModules;
